import { FC } from 'react'
import { Colors } from 'src/components/theme'
import { WidgetCard } from 'src/v2/components/widget-card'
import { PropertyValuationOvertimeChart } from 'src/v2/views/owner-reveal/insights/owner-summary/property-valuation-overtime/chart'
import { PropertyValuationOvertimeFilters } from 'src/v2/views/owner-reveal/insights/owner-summary/property-valuation-overtime/filters'

export const PropertyValuationOvertime: FC = () => {
  return (
    <WidgetCard
      id="property-valuation-overtime"
      title="Property Valuation Overtime"
      headerBgColor={Colors.primaryRed700}
      headerTextColor={Colors.textWhite}
      filters={<PropertyValuationOvertimeFilters />}
      sections={[
        {
          content: <PropertyValuationOvertimeChart />,
        },
      ]}
    />
  )
}
